/** First value of a possibly-repeated (`?k=a&k=b`) query param. */
export const pickString = (value: string | string[] | undefined): string | undefined =>
  Array.isArray(value) ? value[0] : value;

/**
 * Narrows the `?config=` query param to the AccountFormPage config union with a
 * value check rather than an unchecked cast, so an arbitrary query string can
 * never masquerade as the domain literal.
 */
export const pickAccountFormConfig = (
  value: string | string[] | undefined,
): 'resaleClosingDashboard' | undefined =>
  pickString(value) === 'resaleClosingDashboard' ? 'resaleClosingDashboard' : undefined;
